/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdentityClusterEntry } from './IdentityClusterEntry';
import {
    IdentityClusterEntryFromJSON,
    IdentityClusterEntryFromJSONTyped,
    IdentityClusterEntryToJSON,
    IdentityClusterEntryToJSONTyped,
} from './IdentityClusterEntry';

/**
 * 
 * @export
 * @interface IdentityCluster
 */
export interface IdentityCluster {
    /**
     * 
     * @type {Array<IdentityClusterEntry>}
     * @memberof IdentityCluster
     */
    identifiers?: Array<IdentityClusterEntry>;
}

/**
 * Check if a given object implements the IdentityCluster interface.
 */
export function instanceOfIdentityCluster(value: object): value is IdentityCluster {
    return true;
}

export function IdentityClusterFromJSON(json: any): IdentityCluster {
    return IdentityClusterFromJSONTyped(json, false);
}

export function IdentityClusterFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityCluster {
    if (json == null) {
        return json;
    }
    return {
        
        'identifiers': json['identifiers'] == null ? undefined : ((json['identifiers'] as Array<any>).map(IdentityClusterEntryFromJSON)),
    };
}

export function IdentityClusterToJSON(json: any): IdentityCluster {
    return IdentityClusterToJSONTyped(json, false);
}

export function IdentityClusterToJSONTyped(value?: IdentityCluster | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'identifiers': value['identifiers'] == null ? undefined : ((value['identifiers'] as Array<any>).map(IdentityClusterEntryToJSON)),
    };
}

